import { render, staticRenderFns } from "./GeneralSettingBody.vue?vue&type=template&id=342527a8&"
import script from "./GeneralSettingBody.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports